import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExamsService } from '../exams.service';
import { MeasgrowthService } from '../measgrowth.service';

export interface fetalGrowthElement {
  Date: string;
  position: number;
  GA: number;
  EFW: string;
  Headlock: string;
}

@Component({
  selector: 'app-weight-assessment',
  templateUrl: './weight-assessment.component.html',
  styleUrls: ['./weight-assessment.component.scss'],
  standalone: false,
})
export class WeightAssessmentComponent implements OnInit, OnDestroy {
  @Input('print') forprint: boolean;
  @Input('direction') dir: string = 'ltr';
  @Input('fetus') fetus: number;

  displayedColumns: string[] = ['position', 'Date', 'GA', 'EFW', 'Headlock'];
  dataSource = [];
  IsWeightAss = false;
  private fetusSub: Subscription;
  private measSub: Subscription;
  userDefaultTable: object;
  defaultTable: string = 'Hadlock4 (BPD,HC,AC,FL)';

  constructor(
    public examsService: ExamsService,
    public measGrowthService: MeasgrowthService
  ) {}

  ngOnInit() {
    if (!this.forprint) {
      if (this.examsService.getFetus() !== this.fetus) {
        this.fetus = this.examsService.getFetus();
        this.getWeights();
      }
    }

    this.getWeights();

    this.examsService.getDefaultTable().subscribe(
      (data: any) => {
        if (data[0] && data[0].Weight1Type) {
          this.userDefaultTable = data[0].Weight1Type;
        }
      },
      (error) => {
        console.error(error);
      }
    );

    this.fetusSub = this.examsService.fetusChange$.subscribe((res) => {
      this.fetus = res;
      this.getWeights();
    });

    this.measSub = this.measGrowthService.allWeightAssmentsSub.subscribe((res) => {
      if (res) this.getWeights();
    });

    // Sets the calculations based on mesref values:
    this.measSub = this.measGrowthService.addEFW.subscribe((val) => {
      this.dataSource.push({
        position: this.dataSource.length + 1,
        Date: new Date().toISOString().replace('T', ' ').replace('Z', ''),
        GA: this.examsService.examGAByCreation(
          new Date().toISOString().replace('T', ' ').replace('Z', '')
        ),
        EFW: val,
        Headlock: this.measGrowthService.measref['EFW 1'].WeightType,
      });
    });
  }

  ngOnDestroy() {
    if (this.fetusSub) {
      this.fetusSub.unsubscribe();
    }
    if (this.measSub) {
      this.measSub.unsubscribe();
    }
  }

  getWeights() {
    this.examsService
      .getAllWeightAssByPre(this.examsService.pregId, this.examsService.CreationTime, this.fetus)
      .subscribe(
        (res: any) => {
          if (
            this.examsService.ExamType === 'Weight Assessment' ||
            this.examsService.ExamType === 'Tech Exam'
          ) {
            const measRefTable = this.measGrowthService.measref['EFW 1'].WeightType;
            this.measGrowthService.allWeightAssments = [];
            this.dataSource = [];
            var lastWeightTable: any[] = [];
            lastWeightTable = res;
            lastWeightTable.forEach((i) => {
              // For old enteries where Weight1Type was not saved
              if (!i.Weight1Type) {
                if (this.userDefaultTable) {
                  // From defaults
                  i.Weight1Type = this.userDefaultTable;
                }
                if (!this.userDefaultTable && measRefTable) {
                  // From the GUI table selection
                  i.Weight1Type = measRefTable;
                }
              }

              this.dataSource.push({
                position: this.dataSource.length + 1,
                Date: i.CreationTime,
                GA: this.examsService.examGAByCreation(i.CreationTime),
                EFW: this.measGrowthService.calcEFW(i)[0].y,
                Headlock: i.Weight1Type,
              });
            });
            this.IsWeightAss = true;
          } else {
            this.IsWeightAss = false;
          }
        },
        (e) => {
          console.log(e);
        }
      );
  }
}
